import LocalityShow from './LocalityShow'
export {LocalityShow}
export default LocalityShow
